import React from 'react'
import { format } from 'date-fns'
import Avatar from './Avatar'
import { TradeBadges } from './TradieDisplay'

function ListRows({ tradies }) {
  return (
    <div className="table-container">
      <table>
        <thead>
          <tr>
            <th>Name</th>
            <th>Phone</th>
            <th>Trade(s)</th>
            <th>Total Check-ins</th>
            <th>Last Check-in</th>
          </tr>
        </thead>
        <tbody>
          {tradies.map((t) => (
            <tr key={t._id}>
              <td>
                <div className="name-cell">
                  <Avatar firstName={t.firstName} surname={t.surname} />
                  {t.firstName} {t.surname}
                </div>
              </td>
              <td>{t.phone}</td>
              <td>
                <div className="trades-cell">
                  <TradeBadges trades={t.trades} />
                </div>
              </td>
              <td className="center">{t.totalCheckins}</td>
              <td>{t.lastCheckinAt ? format(new Date(t.lastCheckinAt), 'd MMM yyyy') : '—'}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}

export default function TradeGroup({ label, tradies, open, onToggle }) {
  return (
    <div className="trade-group">
      <button
        type="button"
        className="trade-group__header"
        onClick={onToggle}
        aria-expanded={open}
        aria-label={`Toggle ${label} trade group`}
      >
        <span className="trade-group__chevron">{open ? '▼' : '▶'}</span>
        <span className="trade-group__name">{label}</span>
        <span className="trade-group__count">{tradies.length}</span>
      </button>
      {open && <ListRows tradies={tradies} />}
    </div>
  )
}
